module.exports = __webpack_public_path__ + "static/Bodoni-72-Book-c722e8befed4ed21fe6341bb9ef1e787.woff";